//import package
import { combineReducers } from "redux";

import toast from "./toast/toast.reducer";

export default combineReducers({
  toast,
});